'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getEndpoint = require('../get-endpoint');

var _getEndpoint2 = _interopRequireDefault(_getEndpoint);

var _config = require('../config');

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

var _dataProvider = require('../data-provider');

var _dataProvider2 = _interopRequireDefault(_dataProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Gets the product navigation data
 * @param {GetProductNavDataParamsType} params The function parameters
 * @param {TunnelType} params.tunnel The request tunnel
 * @param {String} [params.platform] The platform to get the data for. Accepts: 'desktop' or 'mobile',
 * defaults to mobile
 * @param {String} [params.lang] The language to get the data for. Defaults to 'en-gb'
 * @param {String} [params.siteType] The regulated site to get the data for. Defaults to 'default' (.com)
 * @returns {Promise<ProductList>} A list of Products
 */
exports.default = function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
        var _params$platform, platform, _params$siteType, siteType, _params$lang, lang, tunnel, siteTypeUrl, endpoint, proxyAgent, data;

        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _params$platform = params.platform, platform = _params$platform === undefined ? 'mobile' : _params$platform, _params$siteType = params.siteType, siteType = _params$siteType === undefined ? 'default' : _params$siteType, _params$lang = params.lang, lang = _params$lang === undefined ? 'en-gb' : _params$lang, tunnel = params.tunnel;
                        siteTypeUrl = siteType === 'default' ? '' : '-' + siteType;
                        endpoint = (0, _getEndpoint2.default)('squiz', '/sportsbook' + siteTypeUrl + '/' + lang + '/site-base/products.json');
                        proxyAgent = (0, _config.getProxy)('squiz');
                        _context.next = 6;
                        return (0, _dataProvider2.default)(endpoint, tunnel, {
                            agent: proxyAgent
                        });

                    case 6:
                        data = _context.sent;
                        return _context.abrupt('return', (0, _model2.default)(data, platform));

                    case 8:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function getProductNavData(_x) {
        return _ref.apply(this, arguments);
    }

    return getProductNavData;
}();
//# sourceMappingURL=productNav.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/data-provider/dist/main/product-nav/productNav.js
// module id = 453
// module chunks = 0